import { Module } from 'vuex';
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { serializer } from '../../api/shared/serializer';
import moment from 'moment';
import { LikeTypeEnum } from '@/enums/LikeTypeEnum';
import i18n from "@/plugins/vueI18n";

const likesModule: Module<any, any> = {
  namespaced: false,
  state: {
    familyLikes: [],
  },

  mutations: {
    setFamilyLikes(state: any, payload: []) {
      state.familyLikes = payload;
    }
  },

  actions: {
    async getFamilyLikes({ commit }, range) {

      const fromDate = range?.fromDate || moment().add(-1, "months").toDate();
      const toDate = range?.toDate || moment().add(1, "months").toDate();

      const photoTitleTranslation = i18n.t('Likes.SomeUserLikedYourPhoto')
      const albumTitleTranslation = i18n.t('Likes.SomeUserLikedYourAlbum')
      const eventTitleTranslation = i18n.t('Likes.SomeUserLikedYourEvent')

      try {
        const events = serializer.querySnapshotToDocuments<any>(await firebase.firestore().collection("calender")
          .where("facilityId", "==", this.state.authModule.currentFacility)
          .where("start", ">=", fromDate)
          .where("start", "<=", toDate)
          .get())

        const messages = serializer.querySnapshotToDocuments<any>(await firebase.firestore().collection("messages")
          .where("facilityId", "==", this.state.authModule.currentFacility)
          .where("createdAt", ">=", fromDate)
          .where("createdAt", "<=", toDate)
          .get())

        const residents = this.state.residentModule.residentsShortData

        const eventsLikes = [];

        events.forEach((eventData) => {
          const eventName = eventData.name;
          const eventDate = moment(eventData.start.seconds * 1000).format('DD MMM');

          if (eventData.galleryLikes && eventData.galleryLikes.length) {

            eventData.galleryLikes.forEach((like) => {
              const likeDate = moment((like.date).seconds * 1000)
              eventsLikes.push({
                eventId: eventData.id,
                type: LikeTypeEnum.EventAlbum,
                title: `${like.userName || like.id}${albumTitleTranslation}`,
                likeDateDisplay: `${likeDate.format('DD MMM')}, ${likeDate.format(this.state.facilityModule.selectedFacility.timeFormat)}`,
                eventDateDisplay: eventDate,
                likeDate: likeDate,
                eventName: eventName
              });
            });
          }

          if (eventData.galleryPhotos && eventData.galleryPhotos.length) {
            eventData.galleryPhotos.forEach((photo) => {
              if (photo.likes) {
                photo.likes.forEach((like) => {
                  const likeDate = moment((like.date).seconds * 1000)

                  eventsLikes.push({
                    eventId: eventData.id,
                    type: LikeTypeEnum.EventPhoto,
                    title: `${like.userName || like.id}${photoTitleTranslation}`,
                    likeDateDisplay: `${likeDate.format('DD MMM')}, ${likeDate.format(this.state.facilityModule.selectedFacility.timeFormat)}`,
                    eventDateDisplay: eventDate,
                    likeDate: likeDate,
                    eventName: eventName
                  });
                });
              }
            });
          }

          if (eventData.likes && eventData.likes.length > 0) {
            eventData.likes.forEach((like) => {
              const likeDate = moment((like.date).seconds * 1000)
              eventsLikes.push({
                eventId: eventData.id,
                type: LikeTypeEnum.Event,
                title: `${like.userName || like.id}${eventTitleTranslation}`,
                likeDateDisplay: `${likeDate.format('DD MMM')}, ${likeDate.format(this.state.facilityModule.selectedFacility.timeFormat)}`,
                eventDateDisplay: eventDate,
                likeDate: likeDate,
                eventName: eventName
              });
            });
          }
        });

        const messagesLikes = []

        messages.forEach((messageData) => {
          if (messageData?.likes?.length) {
            const residentName = residents.find(x=>x.id === messageData.residentId)?.name || null 
            messageData.likes.forEach((like) => {
              const likeDate = moment((like.date).seconds * 1000)
              messagesLikes.push({
                messageId: messageData.id,
                type: LikeTypeEnum.MessagePhoto,
                title: `${like.userName || like.id}${photoTitleTranslation}`,
                residentName: residentName,
                likeDateDisplay: `${likeDate.format('DD MMM')}, ${likeDate.format(this.state.facilityModule.selectedFacility.timeFormat)}`,
                likeDate: likeDate
              });
            });
          }
        })

        const familyLikes = eventsLikes.concat(messagesLikes).sort((a, b) => b.likeDate.diff(a.likeDate))

        commit('setFamilyLikes', familyLikes);

      } catch (error) {
        console.error("Getting Likes Error", error);
      }
    }
  }
};
export default likesModule;
